import Logo from '../img/imunis-logo.svg'

const Svg = () => (
    <svg viewBox="0 0 300 150" fill="none" xmlns="http://www.w3.org/2000/svg">
        <image href={Logo} width={177} height={52} x={61.5} y={49} />
    </svg>
)

export default Svg
